import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/Facture/';

export async function get(idFacture) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idFacture } });
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function creationFactureAvoirTotal(
  id, dateAvoir, commentaireAvoir, impactAchatVenteInterne,
) {
  const response = await HTTP.post(URL_BASE + 'AvoirTotalAsync',
    {
      id: id,
      dateAvoir: dateAvoir,
      commentaireAvoir: commentaireAvoir,
      impactAchatVenteInterne: impactAchatVenteInterne,
    });
  return response;
}

export async function getFactureAvoirPartiel(id, dateAvoir, commentaireAvoir) {
  const response = await HTTP.get(URL_BASE + 'GetAvoirPartielAsync', {
    params: {
      id: id,
      DateAvoir: dateAvoir,
      CommentaireAvoir: commentaireAvoir,
    },
  });
  return response;
}

export async function create(facture) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', facture);
  return response;
}

export async function update(facture) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', facture);
  return response;
}

export async function remove(idFacture) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idFacture } });
  return response;
}

export async function updateFactureEnregistrer(facture) {
  const response = await HTTP.put(URL_BASE + 'UpdateFactureEnregistrerAsync', facture);
  return response;
}

export async function brouillon2Facture(idFacture, impactAchatVenteInterne = false) {
  const response = await HTTP.post(URL_BASE + 'Brouillon2FactureAsync', {
    id: idFacture,
    impactAchatVenteInterne: impactAchatVenteInterne,
  });
  return response;
}

export async function factureGeneration(params) {
  const response = await HTTP.post(URL_BASE + 'PFactureGenerationAsync', params);
  return response;
}

export async function pSolderManuellement(ids) {
  const response = await HTTP.post(URL_BASE + 'PSolderManuellementAsync', ids);
  return response;
}

export async function regenererFactureAchat(ids) {
  const response = await HTTP.post(URL_BASE + 'RegenererFactureAchatAsync', ids);
  return response;
}

export async function annulerSoldeManuel(id) {
  const response = await HTTP.post(URL_BASE + 'AnnulerSoldeManuelAsync', { id: id });
  return response;
}

export async function affecterFactorToFacture(params) {
  const response = await HTTP.post(URL_BASE + 'AffecterFactorAsync', params);
  return response;
}

export async function commenterRelance(params) {
  const response = await HTTP.post(URL_BASE + 'CommenterRelanceAsync', params);
  return response;
}
